module.exports = __webpack_public_path__ + "static/media/filled_bar_prewash.a97d873d.svg";